import React from 'react';
import PropTypes from 'prop-types';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {EncodingDatacentersFilter} from '@utils/commonFilters/EncodingDatacentersFilter';

const MediaConnectFilters = ({
    data: {
        encodingDatacenters = [],
    },
    filters,
    loading,
    restoreFilterValues,
}) => {
    return (
        <div className='content__filters'>
            <SearchFilter
                loading={loading}
                filters={filters.mediaConnect}
                restoreFilterValues={restoreFilterValues}
            />
            <EncodingDatacentersFilter
                encodingDatacenters={encodingDatacenters}
                loading={loading}
                filters={filters.mediaConnect}
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

MediaConnectFilters.propTypes = {
    data: PropTypes.shape({
        encodingDatacenters: PropTypes.array,
    }),
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(MediaConnectFilters, {name: 'mediaConnect'});
